import React from "react";
import { Button, ModalProps } from "Components/ReactstrapSlim";
import MessageIcon from "./MessageIcon";
import { VerificationPopUp } from "../../Components";
import { useApiClient } from "Services/API/useApiClient";
import { VenueClaimClient } from "Services/API/API";

import classes from "./VerificationEmailPopUp.module.scss"

export interface VerificationEmailPopUpProps extends ModalProps {
   toggle?: () => void;
   venueId: Guid;
   email?: string | null;
}

const VerificationEmailPopUp: React.FC<VerificationEmailPopUpProps> = ({
   venueId,
   email = "your email",
   ...props
}) => {
   const venueClaimClient = useApiClient(VenueClaimClient);

   const handleResent = async () => {
      await venueClaimClient.claim(venueId, true);
   };

   return (
      <VerificationPopUp
         title="Check your email"
         actionText="Close"
         icon={<MessageIcon />}
         {...props}
      >
         We sent a link to {email} to verify your email. Can’t find the email?{" "}
         <Button color="primary-link" onClick={handleResent} className={classes.resendButton}>
            Resend
         </Button>
      </VerificationPopUp>
   );
};

export default VerificationEmailPopUp;
